import { Box, Typography } from '@mui/material'
import { AppContainer } from '../../ui-kit/AppContainer'
import { BoxContent, BoxFooter, ContainerFooter, TypFooter } from './style'

export const GFooter = () => {
  const currentYear = new Date().getFullYear()

  return (
    <Box sx={BoxFooter}>
      <AppContainer sx={ContainerFooter}>
        <Box sx={BoxContent}>
          <Typography sx={TypFooter}>Все права защищены © {currentYear}</Typography>
        </Box>
      </AppContainer>
    </Box>
  )
}
